// extracted by mini-css-extract-plugin
module.exports = {"GraphicText":"GraphicText_GraphicText__wci6_"};